
import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import PersonalCenter from '@/components/PersonalCenter'
import ErrorMessage from '@/components/ErrorMessage'
import MobileEnroll from '@/components/MobileEnroll'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/:Uid/:ShareId',
            redirect: '/StaffLogin/:Uid/:ShareId'
        },
        {
            path: '/MobileEnroll/:Uid/:ShareId',
            name: 'MobileEnroll',
            component: MobileEnroll
        },
        {
            path: '/PersonalOptions/:Uid/:ShareId',
            name: 'PersonalOptions',
            component: resolve => require(['@/components/PersonalOptions'], resolve)
        },
        {
            path: '/PersonalAddress/:Uid/:ShareId',
            name: 'PersonalAddress',
            component: resolve => require(['@/components/PersonalAddress'], resolve)
        },
        {
            path: '/PersonalCard/:Uid/:ShareId',
            name: 'PersonalCard',
            component: resolve => require(['@/components/PersonalCard'], resolve)
        },
        {
            path: '/PersonalOrder/:Uid/:ShareId',
            name: 'PersonalOrder',
            component: resolve => require(['@/components/PersonalOrder'], resolve)
        },
        {
            path: '/StaffLogin/:Uid/:ShareId',
            name: 'StaffLogin',
            component: resolve => require(['@/components/StaffLogin'], resolve)
        },
        {
            path: '/StaffMiniQr/:Uid/:ShareId',
            name: 'StaffMiniQr',
            component: resolve => require(['@/components/StaffMiniQr'], resolve)
        },
        {
            path: '/StaffCenter/:Uid/:ShareId',
            name: 'StaffCenter',
            component: resolve => require(['@/components/StaffCenter'], resolve)
        },
        {
            path: '/FansCenter/:Uid/:ShareId',
            name: 'FansCenter',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/FansCenter'], resolve)
        },
        {
            path: '/FansTree/:Uid/:ShareId/:FansId',
            name: 'FansTree',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/FansTree'], resolve)
        },
        {
            path: '/StaffCustommallOrder/:Uid/:ShareId',
            name: 'StaffCustommallOrder',
            component: resolve => require(['@/components/StaffCustommallOrder'], resolve)
        },
        {
            path: '/StaffCustommallOrderDetailed/:Uid/:ShareId',
            name: 'StaffCustommallOrderDetailed',
            component: resolve => require(['@/components/StaffCustommallOrderDetailed'], resolve)
        },
        {
            path: '/StaffCustommallIntegralOrder/:Uid/:ShareId',
            name: 'StaffCustommallIntegralOrder',
            component: resolve => require(['@/components/StaffCustommallIntegralOrder'], resolve)
        },
        {
            path: '/StaffCustommallIntegralOrderDetailed/:Uid/:ShareId',
            name: 'StaffCustommallIntegralOrderDetailed',
            component: resolve => require(['@/components/StaffCustommallIntegralOrderDetailed'], resolve)
        },
        {
            path: '/StaffCustommallEventOrder/:Uid/:ShareId',
            name: 'StaffCustommallEventOrder',
            component: resolve => require(['@/components/StaffCustommallEventOrder'], resolve)
        },
        // 配货信息
        {
            path: '/StaffCustommallDistribution/:Uid/:ShareId',
            name: 'StaffCustommallDistribution',
            component: resolve => require(['@/components/StaffCustommallDistribution'], resolve)
        },
        // 统计报表
        {
            path: '/StaffCustommallCount/:Uid/:ShareId',
            name: 'StaffCustommallCount',
            component: resolve => require(['@/components/StaffCustommallCount'], resolve),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/CustommallStatisticsOrderList/:Uid/:ShareId',
            name: 'CustommallStatisticsOrderList',
            component: resolve => require(['@/components/CustommallStatisticsOrderList'], resolve),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/StaffCustommallCountChoice/:Uid/:ShareId',
            name: 'StaffCustommallCountChoice',
            component: resolve => require(['@/components/StaffCustommallCountChoice'], resolve),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/StaffCustommallEventOrderGroup/:Uid/:ShareId',
            name: 'StaffCustommallEventOrderGroup',
            component: resolve => require(['@/components/StaffCustommallEventOrderGroup'], resolve)
        },
        {
            path: '/StaffCustommallEventOrderDetailed/:Uid/:ShareId',
            name: 'StaffCustommallEventOrderDetailed',
            component: resolve => require(['@/components/StaffCustommallEventOrderDetailed'], resolve)
        },
        {
            path: '/StaffCouponVerification/:Uid/:ShareId',
            name: 'StaffCouponVerification',
            component: resolve => require(['@/components/StaffCouponVerification'], resolve)
        },
        {
            path: '/StaffCouponVerificationRecord/:Uid/:ShareId',
            name: 'StaffCouponVerificationRecord',
            component: resolve => require(['@/components/StaffCouponVerificationRecord'], resolve)
        },
        {
            path: '/StaffCouponVerificationResult/:Uid/:ShareId',
            name: 'StaffCouponVerificationResult',
            component: resolve => require(['@/components/StaffCouponVerificationResult'], resolve)
        },
        {
            path: '/StaffCustommallSharingStatistics/:Uid/:ShareId',
            name: 'StaffCustommallSharingStatistics',
            component: resolve => require(['@/components/StaffCustommallSharingStatistics'], resolve)
        },
        {
            path: '/StaffCustommallSharingStatisticsStaffProduct/:Uid/:ShareId',
            name: 'StaffCustommallSharingStatisticsStaffProduct',
            component: resolve => require(['@/components/StaffCustommallSharingStatisticsStaffProduct'], resolve)
        },
        {
            path: '/StaffCustommallSharingStatisticsStaffProductRecord/:Uid/:ShareId',
            name: 'StaffCustommallSharingStatisticsRecord',
            component: resolve => require(['@/components/StaffCustommallSharingStatisticsRecord'], resolve)
        },
        {
            path: '/StaffCustommallSharingStatisticsProduct/:Uid/:ShareId',
            name: 'StaffCustommallSharingStatisticsProduct',
            component: resolve => require(['@/components/StaffCustommallSharingStatisticsProduct'], resolve)
        },
        {
            path: '/StaffCustommallSharingStatisticsProductStaff/:Uid/:ShareId',
            name: 'StaffCustommallSharingStatisticsProductStaff',
            component: resolve => require(['@/components/StaffCustommallSharingStatisticsProductStaff'], resolve)
        },
        {
            path: '/StaffCustommallSharingStatisticsProductRecord/:Uid/:ShareId',
            name: 'StaffCustommallSharingStatisticsProductRecord',
            component: resolve => require(['@/components/StaffCustommallSharingStatisticsProductRecord'], resolve)
        },
        {
            path: '/StaffCustommallPeople/:Uid/:ShareId',
            name: 'StaffCustommallPeople',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/StaffCustommallPeople'], resolve)
        },
        {
            path: '/StaffCustommallPeopleOrder/:Uid/:ShareId',
            name: 'StaffCustommallPeopleOrder',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/StaffCustommallPeopleOrder'], resolve)
        },
        {
            path: '/StaffCustommallEquipment/:Uid/:ShareId',
            name: 'StaffCustommallEquipment',
            component: resolve => require(['@/components/StaffCustommallEquipment'], resolve)
        },
        {
            path: '/BlessingChange/:Uid/:ShareId',
            name: 'BlessingChange',
            component: resolve => require(['@/components/BlessingChange'], resolve)
        },
        {
            path: '/BlessingView/:Uid/:ShareId',
            name: 'Blessing',
            component: resolve => require(['@/components/Blessing'], resolve)
        },
        {
            path: '/StaffCustommallRankingList/:Uid/:ShareId',
            name: 'StaffCustommallRankingList',
            component: resolve => require(['@/components/StaffCustommallRankingList'], resolve)
        },
        // 预约订单
        {
            path: '/StaffCustommallBookingOrder/:Uid/:ShareId',
            name: 'StaffCustommallBookingOrder',
            component: resolve => require(['@/components/StaffCustommallBookingOrder'], resolve)
        },
        {
            path: '/StaffCustommallBookingOrderDetails/:Uid/:ShareId',
            name: 'StaffCustommallBookingOrderDetails',
            component: resolve => require(['@/components/StaffCustommallBookingOrderDetails'], resolve)
        },
        {
            path: '/StaffCustommallRankingStaff/:Uid/:ShareId',
            name: 'StaffCustommallRankingStaff',
            component: resolve => require(['@/components/StaffCustommallRankingStaff'], resolve)
        },
        {
            path: '/StaffCustommallSelfRankingList/:Uid/:ShareId',
            name: 'StaffCustommallSelfRankingList',
            component: resolve => require(['@/components/StaffCustommallSelfRankingList'], resolve)
        },
        {
            path: '/StaffCustommallSelfRankingStaff/:Uid/:ShareId',
            name: 'StaffCustommallSelfRankingStaff',
            component: resolve => require(['@/components/StaffCustommallSelfRankingStaff'], resolve)
        },
        {
            path: '/StaffCustommallSelfRankingStaffOrder/:Uid/:ShareId',
            name: 'StaffCustommallSelfRankingStaffOrder',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/StaffCustommallSelfRankingStaffOrder'], resolve)
        },
        {
            path: '/StaffCustommallHonourManager/:Uid/:ShareId',
            name: 'StaffCustommallHonourManager',
            component: resolve => require(['@/components/StaffCustommallHonourManager'], resolve)
        },
        {
            path: '/StaffCustommallHonour/:Uid/:ShareId',
            name: 'StaffCustommallHonour',
            component: resolve => require(['@/components/StaffCustommallHonour'], resolve)
        },
        {
            path: '/StaffCustommallEquipmentAddress/:Uid/:ShareId',
            name: 'StaffCustommallEquipmentAddress',
            component: resolve => require(['@/components/StaffCustommallEquipmentAddress'], resolve)
        },
        {
            path: '/StaffRegister/:Uid/:ShareId',
            name: 'StaffRegister',
            component: resolve => require(['@/components/StaffRegister'], resolve)
        },
        {
            path: '/StaffPersonalOptions/:Uid/:ShareId',
            name: 'StaffPersonalOptions',
            component: resolve => require(['@/components/StaffPersonalOptions'], resolve)
        },
        {
            path: '/StaffBargain/:Uid/:ShareId',
            name: 'StaffBargain',
            component: resolve => require(['@/components/StaffBargain'], resolve)
        },
        {
            path: '/StaffBargainRecord/:Uid/:ShareId',
            name: 'StaffBargainRecord',
            component: resolve => require(['@/components/StaffBargainRecord'], resolve)
        },
        {
            path: '/StaffIntegralVerification/:Uid/:ShareId',
            name: 'StaffIntegralVerification',
            component: resolve => require(['@/components/StaffIntegralVerification'], resolve)
        },
        {
            path: '/StaffIntegralBagVerification/:Uid/:ShareId',
            name: 'StaffIntegralBagVerification',
            component: resolve => require(['@/components/StaffIntegralBagVerification'], resolve)
        },
        {
            path: '/CustommallStatisticsOrder/:Uid/:ShareId',
            name: 'CustommallStatisticsOrder',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/CustommallStatisticsOrder'], resolve)
        },
        {
            path: '/CustommallStatisticsFans/:Uid/:ShareId',
            name: 'CustommallStatisticsFans',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/CustommallStatisticsFans'], resolve)
        },
        {
            path: '/CustommallStatisticsShare/:Uid/:ShareId',
            name: 'CustommallStatisticsShare',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/CustommallStatisticsShare'], resolve)
        },
        {
            path: '/CustommallStatisticsBrowse/:Uid/:ShareId',
            name: 'CustommallStatisticsBrowse',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/CustommallStatisticsBrowse'], resolve)
        },
        {
            path: '/CustommallStatisticsFansList/:Uid/:ShareId',
            name: 'CustommallStatisticsFansList',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/CustommallStatisticsFansList'], resolve)
        },
        {
            path: '/CustommallStatisticsShareList/:Uid/:ShareId',
            name: 'CustommallStatisticsShareList',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/CustommallStatisticsShareList'], resolve)
        },
        {
            path: '/StaffCustommallPurchaseOrder/:Uid/:ShareId',
            name: 'StaffCustommallPurchaseOrder',
            component: resolve => require(['@/components/StaffCustommallPurchaseOrder'], resolve)
        },
        {
            path: '/StaffCustommallPurchaseOrderDetail/:Uid/:ShareId',
            name: 'StaffCustommallPurchaseOrderDetail',
            component: resolve => require(['@/components/StaffCustommallPurchaseOrderDetail'], resolve)
        },
        {
            path: '/NineBargain/:Uid/:ShareId',
            name: 'NineBargain',
            component: resolve => require(['@/components/NineBargain'], resolve)
        },
        {
            path: '/StaffTrueLoveAdd/:Uid/:ShareId',
            name: 'StaffTrueLoveAdd',
            component: resolve => require(['@/components/StaffTrueLoveAdd'], resolve)
        },
        {
            path: '/StaffTrueLove/:Uid/:ShareId',
            name: 'StaffTrueLove',
            component: resolve => require(['@/components/StaffTrueLove'], resolve)
        },
        {
            path: '/StaffShop/:Uid/:ShareId',
            name: 'StaffShop',
            component: resolve => require(['@/components/StaffShop'], resolve)
        },
        {
            path: '/StaffCustommallChangePriceOrder/:Uid/:ShareId',
            name: 'StaffCustommallChangePriceOrder',
            component: resolve => require(['@/components/StaffCustommallChangePriceOrder'], resolve)
        },
        {
            path: '/StaffCustommallRingOrder/:Uid/:ShareId',
            name: 'StaffCustommallRingOrder',
            component: resolve => require(['@/components/StaffCustommallRingOrder'], resolve)
        },
        {
            path: '/StaffCustommallOfflineOrder/:Uid/:ShareId',
            name: 'StaffCustommallOfflineOrder',
            component: resolve => require(['@/components/StaffCustommallOfflineOrder'], resolve)
        },
        {
            path: '/StaffCustommallChangePriceOrderDetailed/:Uid/:ShareId',
            name: 'StaffCustommallChangePriceOrderDetailed',
            component: resolve => require(['@/components/StaffCustommallChangePriceOrderDetailed'], resolve)
        },
        {
            path: '/ShoppersApply/:Uid/:ShareId',
            name: 'ShoppersApply',
            component: resolve => require(['@/components/ShoppersApply'], resolve)
        },
        {
            path: '/StaffCustommallPrizeOrder/:Uid/:ShareId',
            name: 'StaffCustommallPrizeOrder',
            component: resolve => require(['@/components/StaffCustommallPrizeOrder'], resolve)
        },
        {
            path: '/StaffCustomall15Order/:Uid/:ShareId',
            name: 'StaffCustomall15Order',
            component: resolve => require(['@/components/StaffCustomall15Order'], resolve)
        },
        {
            path: '/StaffIntegral15Verification/:Uid/:ShareId',
            name: 'StaffIntegral15Verification',
            component: resolve => require(['@/components/StaffIntegral15Verification'], resolve)
        },
        // 老叶记同步线下积分
        {
            path: '/IntegralSync/:Uid/:ShareId',
            name: 'IntegralSync',
            component: resolve => require(['@/components/IntegralSync'], resolve)
        },
        // 老叶撤回线下积分
        {
            path: '/WithdrawIntegral/:Uid/:ShareId',
            name: 'WithdrawIntegral',
            component: resolve => require(['@/components/WithdrawIntegral'], resolve)
        },
        {
            path: '*',
            name: 'ErrorMessage',
            component: ErrorMessage,
            children: [
                { path: 'ErrorEcho', component: ErrorMessage },
                { path: 'ErrorEcho/:Uid', component: ErrorMessage },
                { path: 'ErrorEcho/:Uid/:ShareId', component: ErrorMessage }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js